import React, { useState } from "react";
import { TextField, Box } from "@mui/material";
import DateRangePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dateRangePicker.css";
import { ReactComponent as Calender } from "../../assets/icons/calender.svg";
import { ReactComponent as Close } from "../../assets/icons/close-icon.svg";

const DateRangePickerComp = ({ dateRange, setDateRange }) => {
  const [startDate, endDate] = dateRange;
  const formattedDate = (date) =>
    date?.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  const formattedRange = `${
    startDate ? formattedDate(startDate) : "-- / -- /----"
  }${endDate ? "   -   " + formattedDate(endDate) : "   -   -- / -- /----"}`;

  return (
    <Box position="relative">
    <DateRangePicker
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => setDateRange(update)}
      shouldCloseOnSelect={true}
      className="date-range-picker"
      value={formattedRange}
      showIcon
      icon={<Calender />}
      maxDate={new Date()}
      clearAriaLabel="Clear value"
      clearIcon={<Close />}    
    />
    
    {/* Clear Button */}
    {(startDate || endDate) && (
      <Box
        onClick={() => setDateRange([null, null])}
        sx={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 1,
        }}
      >
        <Close />
      </Box>
    )}
  </Box>
  );
};

export default DateRangePickerComp;
